// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"e4197e48","583":"e4197e48","832":"99dcbbe6"}[chunkId] + ".chunk.css";
};